import { render, staticRenderFns } from "./MatchStatus.vue?vue&type=template&id=79baad88&"
import script from "./MatchStatus.vue?vue&type=script&lang=js&"
export * from "./MatchStatus.vue?vue&type=script&lang=js&"
import style0 from "./MatchStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports